<div class="pb-3">
  <h1 class="text-3xl font-bold">Comments ({{ annotationCount }})</h1>
</div>
<div class="w-full">
  <div class="comments-area" #comments>
    <div class="widget-bg-color rounded-xl" *ngFor="let annotation of annotations; let i = index" [class.comment-box]="annotation.attrs.comment && annotation.className !== 'Transformer'">
      <ng-container *ngIf="annotation.attrs.comment && annotation.className !== 'Transformer'">
        <div class="flex">
          <div class="mr-2 text-center">
            <sp-avatar [user]="annotation.attrs.createdBy" [externalFlag]="externalFlag" [size]="avatarSize"></sp-avatar>
          </div>
          <div class="w-[83%]">
            <span>
              <span>#{{ i + 1 }}&nbsp;</span>
              <b>{{ annotation.attrs.createdBy && annotation.attrs.createdBy.name }}</b>
              <span class="float-right">
                {{ annotation.attrs.updatedAt | spDateFormat : { time: true } }}
              </span>
            </span>
            <div class="comment-text">
              {{ annotation.attrs.comment }}
            </div>
            <div class="comment-tools">
              <button *ngIf="assetType === assetTypes.Video" mat-button (click)="annotationTimeClick(annotation.attrs.timestamp)" style="margin-right: 20px">
                <mat-icon class="material-icons-outlined">smart_display</mat-icon> {{ annotation.attrs.timestamp * 1000 | date : 'H:mm:ss' : 'UTC' }}
              </button>
              <button *ngIf="assetType === assetTypes.Pdf" mat-button (click)="annotationPageClick(annotation.attrs.page)">
                <mat-icon class="material-icons-outlined">picture_as_pdf</mat-icon> {{ annotation.attrs.page }}
              </button>
              <button mat-icon-button *ngIf="isSupported" (click)="toggleAnnotation(annotation, i)" i18n-matTooltip [matTooltip]="annotation.attrs.visible === false ? 'Show shape' : 'Hide shape'">
                <mat-icon class="material-icons-outlined" *ngIf="annotation.attrs.visible === true || annotation.attrs.visible === undefined">visibility_off </mat-icon>
                <mat-icon class="material-icons-outlined" *ngIf="annotation.attrs.visible === false">visibility </mat-icon>
              </button>
              <!-- <button
                mat-icon-button
                *ngIf="!readOnly && annotation.attrs.createdBy && annotation.attrs.createdBy.id === currentUser?.userData?._id"
                i18n-matTooltip
                matTooltip="Edit comment"
                (click)="editAnnotation(annotation, i)"
              >
                <mat-icon class="material-icons-outlined">edit</mat-icon>
              </button>
              <button
                mat-icon-button
                *ngIf="!readOnly && annotation.attrs.createdBy && annotation.attrs.createdBy.id === currentUser?.userData?._id"
                i18n-matTooltip
                matTooltip="Delete comment"
                (click)="deleteAnnotation(annotation, i)"
              >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
              </button>
              <button mat-link-button *ngIf="!annotation.attrs.replies || annotation.attrs.replies.length === 0" (click)="replyToAnnotation(annotation, i); replyArea.focus()" class="ml-auto">
                <ng-container i18n>Reply</ng-container>
              </button> -->
            </div>
          </div>
        </div>
      </ng-container>
      <!--Replies-->
      <ng-container *ngIf="annotation.attrs.replies">
        <ng-container *ngFor="let reply of annotation.attrs.replies; let j = index">
          <div class="flex">
            <div class="mr-2 pt-2 text-center">
              <sp-avatar [user]="reply.createdBy" [externalFlag]="externalFlag" [size]="avatarSize"></sp-avatar>
              <mat-icon>subdirectory_arrow_right</mat-icon>
            </div>
            <div class="w-[83%] pt-2">
              <span>
                <b>{{ reply.createdBy.name }}</b>
                <span class="float-right">
                  {{ reply.updatedAt | spDateFormat : { time: true } }}
                </span>
              </span>
              <div class="comment-text">
                {{ reply.comment }}
              </div>
              <div class="comment-tools">
                <button mat-icon-button *ngIf="!readOnly && reply.createdBy.id === currentUser?.userData?._id" (click)="editReply(i, reply, j)">
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
                <button mat-icon-button *ngIf="!readOnly && reply.createdBy.id === currentUser?.userData?._id" (click)="deleteReply(i, j)">
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
                <button mat-link-button *ngIf="j === annotation.attrs.replies.length - 1" (click)="replyToReply(i); replyArea.focus()" class="ml-auto">Reply</button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="widget-bg-color rounded-xl comment-input-box w-100">
    <textarea #replyArea [(ngModel)]="newComment" placeholder="Please add comment.." [disabled]="readOnly && !isReplying"></textarea>
    <div class="text-right w-[100%]">
      <button *ngIf="!isReplying" mat-flat-button class="button-primary !px-4 !py-2" (click)="saveAnnotations()" [disabled]="!newComment">
        <mat-icon class="material-icons-outlined">send</mat-icon>
        <ng-container i18n>Save Comment</ng-container>
      </button>
      <button *ngIf="isReplying" mat-flat-button class="button-primary !px-4 !py-2" (click)="saveAnnotations()" [disabled]="!newComment">
        <mat-icon class="material-icons-outlined">send</mat-icon>
        <ng-container i18n>Save Reply</ng-container>
      </button>
    </div>
  </div>
</div>
